import { createHttpClient } from '@adapters/HttpClient';
import { apiClientWH } from '@shared/services/ApiClient';
import { useToast } from '@shared/hooks/use-toast';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

interface DownloadResponse {
    url_file: string;
}

export const useDownloadCourierFile = () => {
    const [downloadingFileId, setDownloadingFileId] = useState<number | null>(null);
    const { toast } = useToast();
    const { t } = useTranslation('codCourierFiles');

    const downloadFile = async (fileId: number, _fileName?: string) => {
        setDownloadingFileId(fileId);
        try {
            const httpClient = createHttpClient(apiClientWH);
            
            // Hacer la petición GET para obtener la URL del archivo
            const response = await httpClient.get<DownloadResponse>(
                `/courier-cod-files/${fileId}/download`
            );

            // Abrir la URL en una nueva pestaña para descargar
            if (response.url_file) {
                window.open(response.url_file, '_blank');
                
                toast({
                    title: t('download.success.title', 'Descarga exitosa'),
                    description: t('download.success.description', 'El archivo se ha descargado correctamente'),
                    variant: 'default',
                });
            } else {
                throw new Error('No se recibió la URL del archivo');
            }
        } catch (error: any) {
            toast({
                title: t('download.error.title', 'Error al descargar'),
                description: error.message || t('download.error.unexpected', 'Ocurrió un error al descargar el archivo'),
                variant: 'destructive',
            });
        } finally {
            setDownloadingFileId(null);
        }
    };

    return {
        downloadFile,
        downloadingFileId,
        isDownloading: downloadingFileId !== null,
    };
};

